export default "__VITE_ASSET__845c736d__"